import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import GridItem from "../../../components/Grid/GridItem.jsx";
import GridContainer from "../../../components/Grid/GridContainer.jsx";
import Table from "@material-ui/core/Table";
import Card from "../../../components/Card/Card.jsx";
import CardBody from "../../../components/Card/CardBody.jsx";
import Button from "../../../components/CustomButtons/Button.jsx";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import ZoneForm from "./ZoneForm";
import tableViewStyle from "../../../assets/jss/custom-components/tableViewStyle";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableActions from "../../../components/TableActions/TableActions";
import {formTitles} from "../../../utils/statusHelpers";
import {getZonesByStore} from "../../../services/zoneService";
import {withRouter} from "react-router-dom";
import zoneDetails from "../../../models/ZoneModel";
import Loading from "../../../components/Loading/Loading";
import TablePagination from "@material-ui/core/TablePagination";
import {ROWS_PER_PAGE_DETAILS, ROWS_PER_PAGE_OPTIONS_DETAILS} from "../../../variables/apiConstants";
import TableBody from "@material-ui/core/TableBody";
import {getData, nullController, saveData} from "../../../utils/helpersFunctions";
import {
    ENTITY_ZONE,
    NOTIFICATION_DURATION,
    ZONE_DETAILS_TABLE_ACTIONS, ZONE_TYPE_DELIVERY
} from "../../../variables/coreConstants";
import Muted from "../../../components/Typography/Muted";
import {validateSession} from "../../../services/api";
import {withTranslation} from "react-i18next";
import Snackbar from "../../../components/Snackbar/Snackbar";
import NotificationSuccessIcon from "@material-ui/icons/DoneAll";
import {getStatus, statusController} from "../../../services/statusService";


class ZonesDetails extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            openZone: false,
            isLoading: false,
            actionType: 0,
            zonesData: this.props.data,
            filteredZones: this.props.data,
            rowsPerPage: ROWS_PER_PAGE_DETAILS,
            page: 0,
            notificationMessage: '',
            notification: false,
            color: 'success',
            icon: NotificationSuccessIcon,
        };
        this.closeForm = this.closeForm.bind(this);
    }


    handleOpenForm = () => {
        zoneDetails.cleanZoneDetails();
        this.setState({openZone: true});
        this.setState({actionType: 0});
    };
    handleCloseForm = () => {
        this.setState({openZone: false});
    };
    closeForm(state, value, type) {
        this.setState({[state]: value});
        if(type)
            this.request();
    }
    openForm = (action, formData) => {
        zoneDetails.id = formData.id;
        zoneDetails.uuid = formData.uuid;
        zoneDetails.name = formData.name;
        zoneDetails.label = formData.label;
        zoneDetails.description = formData.description;
        zoneDetails.delivery = formData.zoneTypeId === ZONE_TYPE_DELIVERY;
        zoneDetails.type = formData.zoneTypeId;
        zoneDetails.deliveryBlocked = formData.block_delivery;
        zoneDetails.zoneRange = formData.range;
        zoneDetails.externalId = (formData.external_id === null) ? '' : formData.external_id;

        if (action === 1 || action === 0) {
            this.setState({openZone: true});
            this.setState({actionType: action});
        } else {

            let status = getStatus(action);

            if (status !== null) {
                let dataParameters = {
                    "entity": ENTITY_ZONE,
                    "id": zoneDetails.id,
                    "status": status
                };

                statusController(action, null, null, dataParameters, this, true);
            }
        }
    };


    showNotification = (msj, color, icon, refresh) => {
        this.setState({
            notificationMessage: msj,
            color: color,
            icon: icon,
            notification: true,
        });

        window.setTimeout(
            function() {
                this.setState({ notification: false });

                if (refresh != null)
                    this.closeForm("openZone", false, refresh);

            }.bind(this),
            NOTIFICATION_DURATION
        );
    };

    hideNotification = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        this.setState({ notification: false });
    };

    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: + event.target.value});
        this.setState({ page: 0 });
    };


    request(){
        this.setState({ isLoading: true} );
        let store = getData("store");

        let dataParameters = {
            "store_id": store.id
        };

        getZonesByStore(dataParameters)
            .then((res) => {
                this.setState({zonesData: res.data});
                this.setState({filteredZones: res.data});
                this.setState({ isLoading: false} );
                if (res.data.length === 0)
                {
                    this.props.quickAction("isQuickStartZ", true);

                }else {
                    this.props.quickAction("isQuickStartZ", false);
                }
            })
            .catch((err) => {
                this.setState({ isLoading: false} );
                console.log(err);
                if (err.response)
                    validateSession(err.response, this.props.history);
            });
    }

    goToActions = (val) => {
        saveData("zone", val);
        zoneDetails.id = val.id;
        zoneDetails.name = val.name;
        this.props.history.push("quick-actions-zone");
    };


    render() {
        const { classes, t } = this.props;
        const { actionType, page, rowsPerPage } = this.state;

        return (
            <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                    <GridContainer>
                        <GridItem xs={6} sm={6} md={6}>
                            <div className={classes.typo}>
                                <h4> {t('ZONES_TEXT')} </h4>
                            </div>
                        </GridItem>
                        <GridItem xs={6} sm={6} md={6}>
                            <div className={classes.rightPaper}>
                                <Button color="primary" onClick={this.handleOpenForm}>{t('BTN_ADD_NEW_ZONE')}</Button>
                            </div>
                        </GridItem>
                    </GridContainer>
                    {this.state.isLoading ?
                        <Loading/>
                        :
                        <Card className={classes.card}>
                            <CardBody className={classes.cardBodyBottomFit}>
                                <div className={classes.tableResumeResponsive}>
                                    <Table className={classes.table}>
                                        <TableHead className={classes.objectColor}>
                                            <TableRow>
                                                <TableCell
                                                    className={classes.tableCell + " " + classes.tableHeadCell}>
                                                    {t('TH_NAME')}
                                                </TableCell>
                                                <TableCell
                                                    className={classes.tableCell + " " + classes.tableHeadCell}>
                                                    {t('TH_DESCRIPTION')}
                                                </TableCell>
                                                <TableCell
                                                    className={classes.tableCell + " " + classes.tableHeadCell}>
                                                    {t('TH_RANGE')}
                                                </TableCell>
                                                <TableCell
                                                    className={classes.tableCell + " " + classes.tableHeadCell}>
                                                    {t('TH_EXTERNAL_ID')}
                                                </TableCell>
                                                <TableCell
                                                    className={classes.tableCell + " " + classes.tableHeadCell}>
                                                    {t('TH_ACTIONS')}
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {this.state.filteredZones.slice(
                                                page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((val, key) => {
                                                    return (
                                                    <TableRow key={key} hover={true}>
                                                        <TableCell className={classes.tableCell + " " + classes.hoverRow}
                                                                   onClick={() => this.goToActions(val)}>
                                                            {nullController(val, 'name')}
                                                        </TableCell>
                                                        <TableCell
                                                            className={classes.tableCell}>
                                                            {nullController(val, 'description')}
                                                        </TableCell>
                                                        <TableCell className={classes.tableCell}>
                                                            {nullController(val, 'range')}
                                                        </TableCell>
                                                        <TableCell
                                                            className={classes.tableCell}>
                                                            {nullController(val, 'external_id')}
                                                        </TableCell>
                                                        {/*<TableCell
                                                            className={classes.tableCell}>{val.createdByUser}</TableCell>*/}
                                                        <TableCell className={classes.tableCell}>
                                                            {
                                                                <TableActions
                                                                    rowData={val}
                                                                    openForm={this.openForm}
                                                                    options={ZONE_DETAILS_TABLE_ACTIONS}
                                                                />
                                                            }
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })}
                                        </TableBody>
                                    </Table>
                                </div>
                                <TablePagination
                                    rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS_DETAILS}
                                    component="div"
                                    count={this.state.filteredZones.length}
                                    rowsPerPage={this.state.rowsPerPage}
                                    page={this.state.page}
                                    backIconButtonProps={{
                                        'aria-label': 'previous page',
                                    }}
                                    nextIconButtonProps={{
                                        'aria-label': 'next page',
                                    }}
                                    onChangePage={this.handleChangePage}
                                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                />
                            </CardBody>
                        </Card>
                    }
                    <Dialog
                        maxWidth={"md"}
                        fullWidth={true}
                        open={this.state.openZone}
                        onClose={this.handleCloseForm}
                        aria-labelledby="form-dialog-title"
                    >
                        <DialogTitle id="form-dialog-title">
                            {t(formTitles[actionType])} {t('ZONE_TEXT')}
                            <Muted>
                                {t('FORM_NEW_ZONE_DESCRIPTION')}
                            </Muted>
                        </DialogTitle>
                        <DialogContent>
                            <ZoneForm closeForm={this.closeForm} action={actionType}/>
                        </DialogContent>
                    </Dialog>
                </GridItem>
                <Snackbar
                    place="tc"
                    color={this.state.color}
                    icon={this.state.icon}
                    message={this.state.notificationMessage}
                    open={this.state.notification}
                    closeNotification={this.hideNotification}
                    close
                />
            </GridContainer>
        );
    }
}

ZonesDetails.propTypes = {
    classes: PropTypes.object,
    quickAction: PropTypes.func,
    data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
};

export default withRouter(withStyles(tableViewStyle)(withTranslation()(ZonesDetails)));
